exports.width = 24;
exports.height = 24;

exports.svgPathData =
  'M17.706,18.252 L14.004,18.719 L14.164,5.692 L17.883,6.275 L17.883,11.142 L20.681,11.142 L20.362,2.05 C17.706,2.254 15.049,2.312 12.357,2.312 C9.701,2.312 7.026,2.254 4.281,2.05 L3.962,11.142 L6.778,11.142 L6.778,6.275 L10.462,5.692 L10.781,18.719 L6.955,18.252 L6.955,22.711 C9.559,22.565 10.887,22.478 12.322,22.478 C13.845,22.478 15.155,22.594 17.706,22.711 z';
